<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-card-title
            style="padding-bottom: 0"
        >
            <v-text-field
                label="Search Contacts"
                v-model="search_value"
                :placeholder="placeholder"
                clearable
                solo
                flat
                v-on:input="onSearchTextChange"
                autofocus
                autocomplete="off"
            >
                <v-icon
                    slot="prepend"
                    v-on:click="onCancel"
                >
                    mdi-arrow-left
                </v-icon>

                <template
                    v-slot:append-outer
                    v-if="optional"
                >
                    <v-icon
                        v-on:click="onClickSetToEmpty"
                    >
                        mdi-trash-can-outline
                    </v-icon>
                </template>

                <template 
                    v-slot:append-outer
                    v-else
                >
                    <v-tooltip
                        bottom
                    >
                        <template v-slot:activator="{ on }">
                            <v-icon
                                v-on="on"
                                v-on:click="toggleMultiSelect"
                                v-if="!default_multiselect"
                            >
                                {{multiselect_icon}}
                            </v-icon>
                        </template>
                        <span>
                            {{group_text_tooltip}}
                        </span>
                    </v-tooltip>
                </template>
            </v-text-field>
        </v-card-title>

        <v-card-text>
            <v-chip-group
                style="position: fixed; top: 70px; bottom: 10px; left: 10px; right: 10px; overflow-y: scroll;"
            >
                <v-chip
                    v-for="(item, index) in selected_values"
                    :key="index"
                    v-on:click="onRemoveItem(item)"
                    v-on:click:close="onRemoveItem(item)"
                    close
                >
                    {{item.text}}
                </v-chip>
            </v-chip-group>

            <v-btn
                v-if="show_contact_chips"
                v-on:click="onBeginConversation"
                style="position: fixed; top: 70px; right: 50px; z-index: 500"
                color="primary"
            >
                {{action_button_text}}
            </v-btn>


            
            <v-list
                :style="list_styling"
            >
                <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    v-on:click="onClickItem(item)"
                >
                    <slot v-bind:item="item">
                        <v-list-item-content>{{item.text}}</v-list-item-content>
                    </slot>
                </v-list-item>

                <div
                    style="text-align: center; font-weight: bold;"
                    v-if="items != null && items.length >= 240"
                >
                    More results are available than can be shown.  Use the search box at the top to refine your search.
                </div>
                
            </v-list>

            

        </v-card-text>
    </v-card>
</v-dialog>
</template>

<script>

export default {
    props: {
        search: {
            type: Function,
            default: function() { return () => {return [];}; }
        },

        items: {
            type: Array,
            default: function() { return []; }
        },

        placeholder: {
            type: String,
            default: function() { return "Search"; }
        },

        is_multiselect: {
            type: Boolean,
            default: function() { return false; }
        },

        default_multiselect: {
            type: Boolean,
            default: function() { return false; }
        },

        disable_group_text: {
            type: Boolean,
            default: function() { return false; }
        },

        selected_values: {
            type: Array,
            default: function() { return []; }
        },

        action_button_text: {
            type: String,
            default: function() { return 'Begin Conversation'; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            dialog: false,
            search_value: null,
        }
    },

    methods: {

        toggleMultiSelect()
        {
            if ( this.disable_group_text ) return;

            this.$emit('toggle-multiselect');
        },

        showDialog()
        {
            this.search_value = '';
            this.search('');
            this.dialog = true; 
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

        onSearchTextChange(value)
        {
            this.search(value);
        },

        onClickItem(item)
        {
            if ( !this.is_multiselect )
            {
                this.dialog = false;
            }

            // is_selected is a transient variable that's just needed for this dialog
            if ( item.is_selected )
            {
                item.is_selected = false;
            }
            else
            {
                item.is_selected = true;
            }

            this.$emit('input',item);
        },

        onRemoveItem(item)
        {
            for ( let i=0; i < this.items.length; i++ )
            {
                if ( this.items[i].value == item.value )
                {
                    this.items[i].is_selected = false;
                    break;
                }
            }

            this.$emit('remove',item);
        },

        onBeginConversation()
        {
            this.dialog = false;
            this.$emit('begin-conversation', this.selected_values);
        },

        onClickSetToEmpty()
        {
            this.dialog = false;
            this.$emit('input',null);
        },
    },

    computed: {
        group_text_tooltip() 
        {
            if ( this.disable_group_text )
            {
                return 'Carriers do not support group texts from Toll-Free numbers.';
            }

            return 'Group Text';
        },

        list_styling() {
            if ( this.show_contact_chips )
            {
                return 'position: fixed; top: 120px; bottom: 10px; left: 10px; right: 10px; overflow-y: scroll;';
            }
            else
            {
                return 'position: fixed; top: 70px; bottom: 10px; left: 10px; right: 10px; overflow-y: scroll;';
            }
        },

        show_contact_chips() {
            return this.is_multiselect && this.selected_values.length > 0;
        },

        multiselect_icon() {
            if ( this.disable_group_text )
            {
                return "mdi-account-multiple-remove"
            }

            if ( this.is_multiselect )
            {
                return "mdi-account-multiple-check";
            }
            else
            {
                return "mdi-account-multiple";
            }
        }

    },
}
</script>

<style lang="scss" scoped>
</style>